<template>
  <b-card
    no-body
    class="card-employee-task"
  >
    <b-card-header>
      <b-card-title>Soporte técnico de Campus</b-card-title>
    </b-card-header>

    <!-- body -->
    <b-card-body>
      <div
        v-for="(employee) in employeeData"
        :key="employee.userFullName"
        class="employee-task d-flex justify-content-between align-items-center"
      >
        <b-media no-body>
          <b-media-aside class="mr-75">
            <b-avatar
              rounded
              size="42"
              :src="employee.avatar"
            />
          </b-media-aside>
          <b-media-body class="my-auto">
            <h6 class="mb-0">
              <a :href="`mailto:${employee.email}`">{{ employee.userFullName }}</a>
            </h6>
            <small>{{ employee.designation }}</small>
          </b-media-body>
        </b-media>
        <div class="d-flex align-items-center">
          <small class="text-muted mr-75">{{ employee.knowledge }}</small>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BCardHeader, BCardBody, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
/* eslint-disable global-require */
export default {
  components: {
    BCard,
    BCardTitle,
    BCardHeader,
    BCardBody,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
  },
  data() {
    return {
      employeeData: [
        {
          avatar: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          userFullName: 'Mario Rodriguez',
          designation: 'Project Manager',
          email: 'mrodriguezs@indetec.gob.mx',
          knowledge: '[Delivery, Ingreso, Servidores, requerimientos, HelpDesk, ISP]',
        },
        {
          avatar: require('@/assets/images/portrait/small/avatar-s-20.jpg'),
          userFullName: 'Mónica Ramos',
          designation: 'engineer developer',
          email: 'mramosm@indetec.gob.mx',
          knowledge: '[Calificaciones, Re-Inscripcion, Perfil, Asesor, Alumnos, Pagina Publica, Usuarios, Moodle, Reportes, Calificaciones ]',
        },
        {
          avatar: require('@/assets/images/portrait/small/avatar-s-9.jpg'),
          userFullName: 'Cristhian Vázquez',
          designation: 'engineer developer',
          email: 'dvazquezh@indetec.gob.mx',
          knowledge: '[Oferta Academica, Pre-registro, Carrito, Catalogos, Mensajeria, Planes de Estudio, Documentación]',
        },
        {
          avatar: require('@/assets/images/portrait/small/avatar-s-13.jpg'),
          userFullName: 'Daniel Rodriguez',
          designation: 'engineer developer',
          email: 'drodriguezb@indetec.gob.mx',
          knowledge: '[ROOT, Aspirantes, Dash S.E., Dash Alumno, Cuenta, Compras, Matriculación, Facturación (todo lo relacionado), Aprendizaje]',
        },
      ],
    }
  },
}
/* eslint-disable global-require */
</script>
